import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Tooltip
} from '@chakra-ui/react'
import type { FieldProps } from 'formik'
import { Field } from 'formik'
import { isNull, isUndefined } from 'lodash'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import type { CMFieldProps } from '.'
import type { CmFormValues } from '../../../../interfaces/FileDetailsResponse'
import EllipsisMiddle from '../../../EllipsisMiddle'

const CMNumberField = ({
  cmField,
  disabled,
  isUpload,
}: CMFieldProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Field name={`['${cmField.name}']`} key={`['${cmField.name}']`}>
      {({ field, form }: FieldProps<number, CmFormValues>) => (
        <FormControl
          marginBottom={isUpload ? 0 : '30px'}
          isInvalid={Boolean(form.errors[cmField.name])}
          isRequired={cmField.schema.isValueRequired}
          isDisabled={disabled || cmField.schema.readOnly}
        >
          <Tooltip label={cmField.label} placement="top-start">
            <FormLabel requiredIndicator={<></>}>
              <Flex maxWidth="20vw">
                <EllipsisMiddle
                  text={cmField.label}
                  required={cmField.schema.isValueRequired}
                  className="centerText"
                />
              </Flex>
            </FormLabel>
          </Tooltip>
          <Tooltip
            isDisabled={!cmField.schema.readOnly}
            label={t('read_only', 'Read only')}
            shouldWrapChildren
          >
            <Input
              {...field}
              type="number"
              placeholder={
                !(
                  isUndefined(cmField.schema.defaultValue) ||
                  isNull(cmField.schema.defaultValue)
                ) && isUpload
                  ? `${cmField.schema.defaultValue} (Default value)`
                  : ''
              }
              disabled={disabled || cmField.schema.readOnly}
              readOnly={disabled || cmField.schema.readOnly}
              value={
                isUndefined(field.value) || isNull(field.value)
                  ? ''
                  : Number(field.value)
              }
              onChange={e => {
                const value = e.target.value
                if (value.length === 0) {
                  form.setFieldValue(field.name, null)
                } else {
                  const num = parseFloat(value)
                  if (isFinite(num)) {
                    form.setFieldValue(field.name, num)
                  } else {
                    form.setFieldValue(field.name, value)
                  }
                }
              }}
            />
          </Tooltip>
          <FormErrorMessage>{form.errors[cmField.name]}</FormErrorMessage>
        </FormControl>
      )}
    </Field>
  )
}

export default CMNumberField
